/**
 * @author        quanquan
 * @dateTime      2020-12-08 16:45:43
 * @description   meituanIM
 */

import dayjs from 'dayjs'
import { uuid } from '@/module/utils'
import store from '@/conf/home/store'
import Hwebsocket from 'Hwebsocket'

export default class WS {
  constructor (opt) {
    this.token = opt.token || ''
    this.appId = opt.appId || ''
  }

  /**
   * 连接
   */
  IMConnect () {
    const base = 'wss://wpush.meituan.com/websocket'
    const { appId, token } = this
    return new Hwebsocket({ url: `${base}/${appId}/${token}`, pingMsg: `~#HHHBBB#~${token}*`, reconnectTimeout: 30000 })
  }

  /**
   * 发送消息体
   */
  getMsgBody () {
    const { onlineStoreCode, thirdUserId } = store.state.meituanIM.msgSearchParams
    return {
      app_poi_code: onlineStoreCode, // 门店标识
      msg_source: 1, // 消息发送方 商家：1，用户：2
      msg_id: `${uuid(`${thirdUserId}-`)}${uuid()}${uuid()}${uuid()}`,
      cts: dayjs(new Date()).unix(), // 发送时间
      app_id: thirdUserId
    }
  }

  /**
   * 发送文字消息
   */
  IMSendText (opt) {
    const p = _.assign({
      ...this.getMsgBody(),
      msg_type: 1, // 文字：1，图片：2，语音：3
      open_user_id: null,
      msg_content: ''
    }, opt)
    return new Promise((resolve) => {
      this.IMConnect().send(JSON.stringify({ ...p, msg_content: this.encMsg(p.msg_content) }))
      resolve(p)
    })
  }

  /**
   * 发送图片消息
   */
  IMSendImg (opt) {
    const p = _.assign({
      ...this.getMsgBody(),
      msg_type: 2, // 文字：1，图片：2，语音：3
      open_user_id: null,
      msg_content: ''
    }, opt)
    return new Promise((resolve) => {
      this.IMConnect().send(JSON.stringify(p))
      resolve(p)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/module/components/mtIm/_source/ws.js